import { Subscription } from 'rxjs';
import { Directive, OnDestroy } from '@angular/core';

@Directive()
export class EntityWithSubscriptions implements OnDestroy {
  protected subscriptions: Array<Subscription> = [];

  ngOnDestroy() {
    this.subscriptions.forEach(s => s.unsubscribe());
  }
}
